module.exports = __webpack_public_path__ + "img/shopping-cart.13b4cbd8.png";